import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "How much does stump grinding cost in Tucson?",
      answer:
        "Stump grinding in Tucson costs $300 to $850 per stump depending on size, accessibility, and root complexity. Small stumps under 12 inches cost $300-$400, medium stumps 12-24 inches cost $400-$600, and large stumps over 24 inches cost $600-$850. We provide free on-site estimates for accurate pricing, discounts for multiple stumps, and flexible financing options to fit any budget.",
    },
    {
      question: "How deep do you grind stumps?",
      answer:
        "We grind stumps 6 to 12 inches below ground level, which is deep enough for laying sod, planting new trees, or creating garden beds. If you need deeper grinding for construction purposes or specific projects, just let us know and we can accommodate your needs.",
    },
    {
      question: "How long does stump grinding take?",
      answer:
        "Most single stump grinding jobs take 30 minutes to 2 hours depending on stump size and root system. Multiple stumps or very large stumps may take longer. We work efficiently while maintaining quality results and typically complete residential stump removal in a single visit.",
    },
    {
      question: "What happens to the wood chips after grinding?",
      answer:
        "After stump grinding, the remaining wood chips (mulch) can be left in the hole and surrounding area as free mulch, spread across your garden beds, or hauled away for a small additional fee. Most Tucson homeowners love reusing the mulch for desert landscaping.",
    },
    {
      question: "Will the stump regrow after grinding?",
      answer:
        "Grinding a stump below ground level prevents regrowth in most cases. Some species like elms or aspens may produce root suckers. We can apply root killer if you're concerned about regrowth, or perform additional root grinding to address surface roots.",
    },
    {
      question: "Do you need to mark utility lines before grinding?",
      answer:
        "Yes, for safety we recommend calling 811 (Arizona Blue Stake) before any stump grinding work. This free service marks underground utilities on your property. We can schedule around the marking process, which typically takes 2-3 business days.",
    },
    {
      question: "Can you grind stumps in tight spaces or backyards?",
      answer:
        "Absolutely! We have compact stump grinding equipment specifically designed for tight access areas. Our smallest grinder can fit through a 36-inch gate. If standard equipment won't fit, we have alternative solutions for any backyard or commercial space.",
    },
    {
      question: "What areas do you service for stump grinding near me?",
      answer:
        "We provide stump grinding and tree stump removal services throughout the greater Tucson metropolitan area including Tucson, Oro Valley, Catalina, Sahuarita, SaddleBrooke, Oracle, Marana, and surrounding communities. If you're searching for stump grinding near me, give us a call — we likely cover your area!",
    },
    {
      question: "Do I need to be home during the stump grinding?",
      answer:
        "No, you don't need to be home as long as we have access to the stump. Many customers provide gate codes or leave side gates unlocked. We send before-and-after photos when the job is complete, and payment can be arranged in advance.",
    },
    {
      question: "Do you offer financing for stump grinding?",
      answer:
        "Yes! We offer flexible financing options to make stump grinding affordable for every budget. Whether you have one stump or multiple stumps to remove, we can work with you to create a payment plan. Ask about our financing options when you request your free quote.",
    },
    {
      question: "Are you a licensed and insured stump removal service?",
      answer:
        "Yes, Tucson Stump Grinding is fully licensed and carries comprehensive liability insurance for all stump grinding and tree stump removal work. This protects both you and our crew. We're happy to provide proof of insurance upon request.",
    },
  ];

  return (
    <section id="faq" className="py-16 lg:py-24 bg-[#F5F5F0]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="accent-line mx-auto mb-4" />
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] uppercase mb-4">
            Frequently Asked Questions
          </h2>
          <p className="font-body text-lg text-gray-600 max-w-2xl mx-auto">
            Got questions about stump grinding in Tucson? We've got answers. If you don't see your question here, feel free to contact us.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="faq-item bg-white px-6"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="font-heading text-base sm:text-lg font-bold text-[#1A1A1A] text-left hover:text-[#FF4D00] py-5 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-body text-gray-600 pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Still Have Questions */}
        <div className="mt-12 bg-[#1A1A1A] p-8 text-center relative overflow-hidden noise-bg">
          <div className="relative z-10">
            <h3 className="font-heading text-xl sm:text-2xl font-bold text-white uppercase mb-4">
              Still Have Questions?
            </h3>
            <p className="font-body text-gray-400 mb-6">
              We're here to help. Contact us for a free consultation and quote.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+15202007739,2"
                className="btn-primary px-8 py-3 inline-block"
                data-testid="faq-call-btn"
              >
                Call (520) 200-7739 Ext 2
              </a>
              <a
                href="#contact"
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#1A1A1A] px-8 py-3 font-heading font-bold uppercase tracking-wide transition-colors inline-block"
                data-testid="faq-contact-btn"
              >
                Send Message
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
